import React, { HTMLAttributes, useCallback, useMemo } from "react";
import { observer } from "mobx-react-lite";
// import { useRouter } from "next/router";
import cx from "classnames";
import { Util } from "@xt/xtbase";
// const { useTranslation } = Hooks;
const { moment } = Util;
import store from "store";
import { getUpDownCls, filterBigNumThousands } from "utils/method";

import XtFontScale from "components/xt/fontScale";

import styles from "./index.module.scss";

import { TradeRecentProps } from "store/trade";

interface Props extends HTMLAttributes<HTMLDivElement> {
  // startIndex?: number;
  // index?: number;
  doc: TradeRecentProps;
}

const Main: React.FC<Props> = ({ className, doc, ...rest }) => {
  // const router = useRouter();

  // const { currentConfig } = store.market;

  const docFormat = useMemo(() => {
    return {
      timeLab: moment(doc.t).format("HH:mm:ss"),
      priceCls: getUpDownCls(doc.b ? 1 : -1),
      priceLab: filterBigNumThousands(doc.p),
      amountLab: filterBigNumThousands(doc.q),
      // priceLab: filterBigNumThousands(doc.p, currentConfig.pricePrecision),
      // amountLab: filterBigNumThousands(doc.q, currentConfig.quantityPrecision),
    };
  }, [doc]);
  // }, [doc, currentConfig]);

  const handleClick = useCallback(() => {
    store.trade.updateState({
      tradeRecentOnce: {
        ...doc,
        isClick: true,
      },
    });
  }, [doc]);

  return (
    <div onClick={handleClick} className={cx(styles.main, className)} {...rest}>
      <XtFontScale>{docFormat.timeLab}</XtFontScale>
      <XtFontScale className={docFormat.priceCls}>{docFormat.priceLab}</XtFontScale>
      <XtFontScale>{docFormat.amountLab}</XtFontScale>
    </div>
  );
};

export default observer(Main);
